import i18next from "i18next";
import fallback from "./fallback";
// import enCommonds from './enCommonds';

export const setI18nConfig = async (s3Path, languajes) => {
  // Esperamos al init (es asíncrono) y cargamos el diccionario de fallback local
  // YA en los resources iniciales. Antes el fallback se añadía DESPUÉS y sin
  // esperar al init: si la promesa del init se resolvía más tarde, reseteaba los
  // bundles (resources: {}) y $t devolvía la propia clave, viéndose los campos
  // como "interveners.document_type.CIF" hasta recargar (F5). [GES-294]
  await i18next.init({
    lng: "es",
    fallbackLng: "fallback",
    resources: {
      fallback: { translation: fallback }
    }
  });

  if (languajes && languajes.length > 0) {
    const translationUrls = {};
    languajes.forEach(languaje => {
      translationUrls[
        languaje.toLowerCase()
      ] = `${s3Path}/texts/bo/${languaje.toLowerCase()}/index.json`;
    });
    const locales = Object.keys(translationUrls);

    for (const locale of locales) {
      const lowerCaseLocale = locale.toLowerCase();
      const url = translationUrls[lowerCaseLocale];
      try {
        const response = await fetch(url);
        let data = await response.json();

        // if (locale === "en") data = { ...data, ...enCommonds };

        i18next.addResourceBundle(lowerCaseLocale, "translation", data);
      } catch (error) {
        console.warn(
          `Failed to load translations for ${lowerCaseLocale}:`,
          error
        );
      }
    }
  }
};

export default i18next;